<template>
  <v-container class="metadata-container">
    <!-- Close Button and Title -->
    <v-row class="header dense no-gutters">
      <v-col cols="10">
        <b class="header-title">
          Selected Record: <span v-text="' ' + metadataObject?.gendib_pop_id"></span>
        </b>
      </v-col>
      <v-col cols="2" class="close-btn-col">
        <button @click="$emit('close')" class="close-button">X</button>
      </v-col>
    </v-row>
    <!-- Metadata Properties Display -->
    <v-row dense no-gutters>
      <v-col>
        <v-text-field
          class="font-style-attributes"
          readonly
          dense
          hide-details
          label="Species"
          :model-value="`${metadataObject?.species_scientific || 'N/A'}`"
          density="compact"
        />
      </v-col>
    </v-row>
    <v-row dense no-gutters>
      <v-col>
        <v-text-field
          class="font-style-attributes"
          readonly
          dense
          hide-details
          label="Data Set Published"
          :model-value="`${metadataObject?.data_set_published || 'N/A'}`"
          density="compact"
        />
      </v-col>
    </v-row>
    <v-row dense no-gutters>
      <v-col>
        <v-text-field
          class="font-style-attributes"
          readonly
          dense
          hide-details
          label="Marker"
          :model-value="`${metadataObject?.marker_types || 'N/A'}`"
          density="compact"
        />
      </v-col>
    </v-row>

    <!-- Links as Buttons -->
    <v-row v-if="metadataObject && metadataObject.article_link">
      <v-col>
        <v-btn block
               class="font_style_links"
               color="primary"
               @click="openLink(metadataObject.article_link)"
               density="compact">
          Open Article (DOI)
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="metadataObject && metadataObject.data_link" dense>
      <v-col>
        <v-btn block
               class="font_style_links"
               color="primary"
               @click="openLink(metadataObject.data_link)"
               density="compact">
          Open Data (DOI)
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent} from "vue";
import type { PropType } from 'vue';


export default defineComponent({
  props: {
    metadataObject: {
      type: Object as PropType<{ [key: string]: any }>,
      default: () => ({})
    }
  },
  emits: ['close'],
  methods: {
    openLink(url: string) {
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
  watch: {
    metadataObject(newVal) {
      console.log('metadataObject:', newVal);
    }
  },
})
</script>

<style scoped>
.metadata-container {
  max-width: 300px; /* Adjust to the desired width */
  margin: 20px auto; /* Center the container with margin at the top and bottom */
  padding: 16px;
  border-radius: 8px; /* Rounded corners for aesthetics */
  box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Soft shadow for depth */
  background: #f5f5f5; /* Light grey background for the container */
  overflow: hidden; /* Prevents background from spilling outside the border-radius */
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.header-title {
  font-size: 14px; /* Adjust the font size as needed */
  color: black;
}

.close-btn-col {
  flex: none; /* Prevents the close button column from growing */
}
.close-button {
  border: none;
  background: none;
  cursor: pointer;
  color: #757575; /* Grey color for the close button */
}
.font_style_links {
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  color: #333;
  font-size: x-small;
}
.font-style-attributes {
  font-family: 'Arial', sans-serif;
  color: #333;
  font-size: xx-small;
}
@media (max-width: 600px) {
  .metadata-container {
    max-width: 90%;
    padding: 8px;
  }
}
</style>

